/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CssBaseline,
  ThemeProvider,
  Typography,
} from '@mui/joy';
import { KeyboardArrowRight } from '@mui/icons-material';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import { useParams } from 'react-router-dom';
import SettlementGroupForm from './widgets/SettlementGroupForm';
import { theme } from '../../main/theme/constants';

export default function SettlementGroupDetailScreen() {
  const { id } = useParams();
  const { t } = useTranslation('ui');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box m={3}>
        <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs">
          <Link color="neutral" href="/settings/settlementgroups">
            {t('nav.settlementGroups')}
          </Link>
          <Typography>{t('settlementGroups.breadcrumbDetail')}</Typography>
        </Breadcrumbs>
        <Typography level="h1" textAlign="start" sx={{ mb: 2 }}>
          {t('settlementGroups.detailTitle')}
        </Typography>

        <SettlementGroupForm
          mode="edit"
          groupId={id}
          hideBreadcrumbs
          embed
        />
      </Box>
    </ThemeProvider>
  );
}
